import { render, staticRenderFns } from "./quartz.vue?vue&type=template&id=f0df5ddc"
import script from "./quartz.vue?vue&type=script&lang=js"
export * from "./quartz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports